import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTodoistComponent } from './simple-icons-todoist.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTodoistComponent ],
    exports:      [ SimpleIconsTodoistComponent ],
    bootstrap:    []
})
export class SimpleIconsTodoistModule {}
